import { CatalogItemKind, isSyntheticCatalogTrackMaid } from 'fym-shared/src/smartlinks/catalog';
import { CatalogItem } from '../../../redux/api/fymAPI.types';

/** Which of the sheet's two starting points a row is opened on. */
export interface CatalogCreationSource {
  catalogTrackMaid?: string;
  catalogItemUuid?: string;
}

/**
 * How "Create link" opens the sheet on a row.
 *
 * A row that names a real catalog track is opened by maid: the sheet reads the
 * track out of musicapi and gets the links, the cover and the date with it.
 * Every other row is opened by uuid and resolved out of what the row itself
 * holds — an unreleased row has nothing to read, and a row claimed off a
 * profile or added by hand carries a synthetic key that musicapi answers
 * nothing for. Sending one of those as a maid would spin, then fail, on a row
 * that already has everything the page needs.
 */
export function catalogCreationSource(item: CatalogItem | undefined): CatalogCreationSource {
  if (item === undefined) {
    return {};
  }
  if (
    item.kind === CatalogItemKind.unreleased ||
    item.catalogTrackMaid === null ||
    isSyntheticCatalogTrackMaid(item.catalogTrackMaid)
  ) {
    return { catalogItemUuid: item.uuid };
  }
  return { catalogTrackMaid: item.catalogTrackMaid };
}
